// Separate cache configuration file for better organization
import { InMemoryCache } from '@apollo/client'

export const createApolloCache = () => {
  return new InMemoryCache({
    possibleTypes: {
      LearningFeatureV2: ['LearningFeatureTranslationV2', 'LearningFeatureGrammarV2'],
      LessonBlock: [
        'LessonBlockActivity',
        'LessonBlockFreeText',
        'LessonBlockWarmUp',
        'LessonBlockBookOrientation',
        'LessonBlockMistakes',
        'LessonBlockContent'
      ]
    },
    typePolicies: {
      Query: {
        fields: {
          // Pagination queries
          searchCoverImages: {
            keyArgs: ['search', 'subject'],
            merge(existing = [], incoming, { args }) {
              if (args?.page?.from === 0) return incoming
              return [...existing, ...incoming]
            }
          }
        }
      },
      LearningFeatureTranslationV2: {
        keyFields: ['id']
      },
      LearningFeatureGrammarV2: {
        keyFields: ['id']
      }
    }
  })
}
